import { render } from "./Cargo.vue?vue&type=template&id=3f288dfb&scoped=true"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"

import "./Cargo.vue?vue&type=style&index=0&id=3f288dfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f288dfb"]])

export default __exports__